import { render } from "./BuildingDetail.vue?vue&type=template&id=cca329fc"
import script from "./BuildingDetail.vue?vue&type=script&lang=js"
export * from "./BuildingDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__